import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=b5e83808&"
import script from "./PasswordForm.vue?vue&type=script&lang=js&"
export * from "./PasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports